import {Component, OnDestroy, OnInit} from '@angular/core';
import {PageService} from '../services/page.service';
import {ExpedientesService} from '../services/expedientes.service';
import {Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {FormControl, FormGroup} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ColaboradoresModalComponent} from '../modal/colaboradores-modal/colaboradores-modal.component';
import {CambioModalComponent} from '../modal/cambio-modal/cambio-modal.component';
import {MatDialog} from '@angular/material/dialog';
import {
  MatriculacionAtajoModalComponent
} from '../../components/modales_atajos/matriculacion-atajo-modal/matriculacion-atajo-modal.component';
import {
  AyudaAtajoModalComponent
} from '../../components/modales_atajos/ayuda-atajo-modal/ayuda-atajo-modal.component';
import {DobleTrAtajoModalComponent} from '../../components/modales_atajos/doble-tr-atajo-modal/doble-tr-atajo-modal.component';
import {BajaAtajoModalComponent} from '../../components/modales_atajos/baja-atajo-modal/baja-atajo-modal.component';
import {FirmaDocumentosAtajoModalComponent} from '../../components/modales_atajos/firma-documentos-atajo-modal/firma-documentos-atajo-modal.component';
import { transform } from 'typescript';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  fromDate: Date;
  toDate: Date;
  // Subs
  public serviceSubscription = new Subscription();
  // Estadisticas
  public listEstadisticas ;
  public estats: number [] = [];
  public dats: number [] = [];
  public labels: string [] = [];
  public desde: string;
  public hasta: string;
  rol;
  colaboradores;
  expedientesRaw;
  public rango = {
    inicio: 0,
    fin: 0
  };

  public estadistica = {
    matriculaciones : 0,
    cambioPropiedad: 0,
    distintivo: 0,
    expIncidencias: [],
    incidencias: 0,
    informe: 0,
    justificante: 0,
    meses: [0 , 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  };

  // Tabla
  public datasource = null;
  displayedColumns: string[] = ['expediente', 'tramite', 'estado', 'recepcion'];

  pintar = false;

  // Datos
  datos: any;
  datosCuadros: any;

  estadisticas: any [] = [];

  tipo: any;
  colaborador: any;

   // Spinner
  spinner = true;

  init = new Date(new Date().getFullYear(), 0, 1);
  today = new Date();

  // Form
  dateForm = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
    colaborador: new FormControl()
  });
  cargar = false;
  fechas: any;

  nifColaborador;
  codigoColaborador;
  parse = false;

  constructor(private expedientesServices: ExpedientesService, private pagesService: PageService, private router: Router, 
    private date: DatePipe, private dialog: MatDialog) {
      this.colaboradores = JSON.parse(sessionStorage.getItem('colaboradores'));
      this.nifColaborador = JSON.parse(sessionStorage.getItem('nifColaboradores'));
      this.codigoColaborador = JSON.parse(sessionStorage.getItem('codigoColaboradores'));
      this.estadistica = this.pagesService.estadistica;
      this.estadisticas = this.pagesService.estadisticas;
      this.expedientesRaw = this.pagesService.expedientes;
      if (this.estadistica === undefined && this.estadisticas === undefined && this.expedientesRaw === undefined) {
        this.cargar = true;
      }
      console.log(this.estadisticas, this.estadistica, this.expedientesRaw);
    }

  async ngOnInit(): Promise<void> {
    this.calcularFecha();
    console.log(this.fromDate);
    console.log(this.toDate);
    console.log(this.init);
    this.rol = sessionStorage.getItem('rol');
    let colaborador: any = null;
    switch (this.rol){
      case 'GRUPO':
        colaborador = JSON.parse(sessionStorage.getItem('colaboradores'));
        this.colaboradores = JSON.parse(sessionStorage.getItem('colaboradores'));
      break;

      default:
        colaborador = sessionStorage.getItem('colaborador');
        this.dateForm.controls['colaborador'].setValue(colaborador);
        console.log(this.dateForm.controls['colaborador'].value);
      break;
    }

    this.serviceSubscription = this.expedientesServices.getExpedientesEstadisticas(colaborador).subscribe(
      (res) => {
        this.estadistica = res;
        console.log(this.estadistica);

        this.datosCuadros = res;
        this.listEstadisticas = res;
        this.dats = this.listEstadisticas['meses'];
        console.log(this.listEstadisticas);
        this.extraerDatos(this.listEstadisticas);
      },
      (error) => {
        console.log(error);
      }
    );

    this.datasource = new MatTableDataSource();
    this.expedientesServices.getExpedientes(colaborador).subscribe(res => {
      this.datos = res.items;
      this.setDatos(res.items);
    });
  }

  async ngOnDestroy(): Promise<void> {
    this.serviceSubscription.unsubscribe();
    await this.pagesService.setExpedientes(this.expedientesRaw);
    console.log(this.estadisticas);
    await this.pagesService.setEstadisticas(this.estadisticas, this.estadistica);
  }

  calcularFecha(): void {
    this.fromDate = new Date(new Date().getFullYear(), 0, 1);
    this.toDate = new Date(new Date().getFullYear(), 12, 0);
  }

  extraerDatos(datos): void{
    this.estats[0] = (datos['matriculaciones']);
    this.estats[1] = (datos['cambioPropiedad']);
    this.estats[2] = (datos['distintivo']);
    this.estats[3] = (datos['justificante']);
    this.estats[4] = (datos['informe']);
    this.estats[5] = (datos['reduccion']);
    console.log(this.estats);
  }

  setDatos(datos): void{
    const temp = [];
    if ( datos?.length > 3){
      temp.push(datos[datos.length - 1]);
      temp.push(datos[datos.length - 2]);
      temp.push(datos[datos.length - 3]);
      this.datasource.data = temp;
    }else {
      this.datasource.data = datos;
    }
    this.spinner = false;
  }

  navigate(tramite: string): void {
    this.router.navigate(['/page/expedientes'], { state: { tramite } });
  }

  navigateIncidencias(): void {
    console.log(this.listEstadisticas);
    this.router.navigate(['/page/expedientes'], { state: { incidencias: 'INCIDENCIA' } });
  }

  getDateFrom(): Date {
    return this.dateForm.get('fromDate').value;
  }

  getToDate(): Date {
    return this.dateForm.get('toDate').value;
  }

  filterByDateRange(): void {
    this.fromDate = this.dateForm.controls['fromDate'].value;
    this.toDate = this.dateForm.controls['toDate'].value;
    this.spinner = true;
    this.pintar = false;
    console.log(this.dateForm.value.colaborador);
    let datos = [];
    let colaborador: any;
    if (sessionStorage.getItem('rol') === 'GRUPO'){
      console.log(this.dateForm.controls['colaborador'].value)
      if (this.dateForm.controls['colaborador'].value === ''){
        colaborador = sessionStorage.getItem('colaboradores');
      } else {
        console.log("Parse", this.parse);
        /*colaborador = [] ;
        const i: number  = + this.dateForm.controls['colaborador'].value;
        colaborador.push(this.colaboradores[i]);
        colaborador = JSON.stringify(colaborador);*/
        if (this.parse) {
          colaborador = sessionStorage.getItem('colaborador');
        } else {
          colaborador = JSON.stringify(sessionStorage.getItem('colaborador'));
        }
        
      }
    } else {
      colaborador = [] ;
      colaborador.push(sessionStorage.getItem('colaborador'));
      colaborador = JSON.stringify(colaborador);
    }
    console.log(colaborador);
    this.expedientesServices.getExpedientesEntreFechas(this.getDateFrom(), this.getToDate(), colaborador).subscribe( (res) => {
      console.log(res);
      // @ts-ignore
      datos = res;
      const label = [];
      const data = [];
      let contador = 0;
      const tipos = {
        matriculaciones: 0,
        cambioPropiedad: 0,
        distintivo: 0,
        justificante: 0,
        informe: 0
      };
      console.log(datos);
      if (this.getDateFrom() && this.getToDate()) {
        datos.map( (a, i) => {
          if ( i > 0 && label[ i - contador] !== this.date.transform(a.fechaEntrada, 'dd/MM/yy')) {
            label.push(this.date.transform(a.fechaEntrada, 'dd/MM/yy'));
            data.push(1);
            contador --;
          }
          if ( i === 0) {
            label.push(this.date.transform(a.fechaEntrada, 'dd/MM/yy'));
            data.push(1);
          }
          if ( label[ i - contador] === this.date.transform(a.fechaEntrada, 'dd/MM/yy')){
            data[i - contador] ++;
          }
          contador ++;
          if ( a.tramite.toLowerCase().includes('matriculaci')){
            tipos.matriculaciones ++;
          } else if ( a.tramite.toLowerCase().includes('cambio de pr')){
            tipos.cambioPropiedad ++;
          } else if ( a.tramite.toLowerCase().includes('distintivo')){
            tipos.distintivo ++;
          } else if ( a.tramite.toLowerCase().includes('justificante')){
            tipos.justificante ++;
          } else if ( a.tramite.toLowerCase().includes('informe')){
            tipos.informe ++;
          }
        });
      }
      this.datosCuadros = tipos;
      this.extraerDatos(tipos);
      this.desde = this.date.transform(this.getDateFrom(), 'dd-MM-yy');
      this.hasta = this.date.transform(this.getToDate(), 'dd-MM-yy');
      this.labels = label;
      this.dats = data;
      setTimeout(() => {
        this.pintar = true;
        this.setDatos(datos);
      }, 1000);
    });

  }

  restablecer(): void{

    this.spinner = true;
    setTimeout(() => {
      this.pintar = false;
      this.dateForm.reset();
      this.listEstadisticas = this.estadistica;
      this.datosCuadros = this.estadistica;
      this.extraerDatos(this.estadistica);
      this.setDatos(this.datos);
    }, 500);

  }

  getExpedientes(colaborador): Promise<any>{
    return new Promise( resolve => {
      this.expedientesServices.getExpedientes(colaborador).subscribe(res => {
        resolve(res);


      });
    });

  }

  getEstadisticas(colaborador): Promise<any>{
    return new Promise( resolve => {
      this.serviceSubscription = this.expedientesServices.getExpedientesEstadisticas(colaborador).subscribe(
        (res) => {
          this.estadisticas.push(res);
          resolve(res);
        },
        (error) => {
          resolve(null);
        }
      );
    });

  }

  applyFilter(event): void{
    sessionStorage.setItem('colaborador', '');
    console.log(event);
    if (event === 'TODOS') {
      this.parse = true;
      console.log("Colaboradores", this.colaboradores);
      sessionStorage.setItem('colaborador', JSON.stringify(this.colaboradores));
    } else {
      this.parse = false;
      sessionStorage.setItem('colaborador', event);
    }
    /*this.spinner = true;
    const id = this.dateForm.value.colaborador;
    console.log(this.dateForm.value.colaborador);
    console.log(this.estadisticas);
    const filterStats = this.estadisticas[this.dateForm.value.colaborador];
    const filterExp = this.expedientesRaw[this.dateForm.value.colaborador];
    this.dateForm.controls['fromDate'].reset();
    this.dateForm.controls['toDate'].reset();
    console.log(filterStats);
    this.listEstadisticas = filterStats;
    this.datosCuadros = filterStats;
    setTimeout(() => {
      this.setDatos(filterExp);
      this.extraerDatos(filterStats);
    }, 1000);*/


  }

  toGoCambio(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO'){
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: {colaborador: this.colaborador},
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.modalCambio();
        }
      });
    } else {
      this.modalCambio();
    }
  }

  toGoInforme(): void {
    sessionStorage.setItem('id', 'null');
    sessionStorage.setItem('tipoCliente', 'null');
    if (this.rol === 'GRUPO'){
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: {colaborador: this.colaborador},
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.router.navigate(['page/informe']);
        }
      });
    } else {
      this.router.navigate(['page/informe']);
    }
  }

  toGoReduccion(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO'){
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: {colaborador: this.colaborador},
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.modalDobleCambio();
        }
      });
    } else {
      this.modalDobleCambio();
    }
  }

  toGoDistintivo(): void{
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO'){
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: {colaborador: this.colaborador},
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.router.navigate(['page/distintivo']);
        }
      });
    } else {
      this.router.navigate(['page/distintivo']);
    }
  }

  toGoJustificante(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO'){
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: {colaborador: this.colaborador},
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.router.navigate(['page/justificante']);
        }
      });
    } else {
      this.router.navigate(['page/justificante']);
    }
  }

  toGoMatriculacion(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO'){
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: {colaborador: this.colaborador},
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.modalMatriculacion();
        }
      });
    } else {
      this.modalMatriculacion();
    }
  }

  toGoAyudas(): void {
    sessionStorage.setItem('id', 'null');
    sessionStorage.setItem('tipo', 'null');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log('Result', result);
        if (result !== undefined) {
          //this.isExpanded = !this.isExpanded;
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          sessionStorage.setItem('codigoColaborador', result.codigo);
          //this.router.navigate(['page/ayudas']);
          this.modalAyudas();
          
        }
      });
    } else {
      //this.isExpanded = !this.isExpanded;
      //this.router.navigate(['page/ayudas']);
      this.modalAyudas();
    }
  }

  modalMatriculacion(): void{
    sessionStorage.setItem('tipoCliente', '1');
    const dialogRef = this.dialog.open(MatriculacionAtajoModalComponent, {
      width: '40%',
      data: {tipo: this.tipo},
      hasBackdrop: true,

    });
    dialogRef.afterClosed().subscribe(result => {
      if(result !== undefined && result !== "") {
        console.log(result.value);
        sessionStorage.setItem('tipo', result.value.tipoTramite);
        sessionStorage.setItem('km', result.value.km);
        sessionStorage.setItem('paisOrigen', result.value.paisOrigen);
        sessionStorage.setItem('numPedido', result.value.numPedido);
        this.router.navigate(['page/matriculacion']);
      }
    });
  }

  modalAyudas(): void{
    sessionStorage.setItem('tipoCliente', '1');
    const dialogRef = this.dialog.open(AyudaAtajoModalComponent, {
      width: '40%',
      data: {tipo: this.tipo},
      hasBackdrop: true,

    });
    dialogRef.afterClosed().subscribe(result => {
      if(result !== undefined && result !== "") {
        console.log(result.value);
        sessionStorage.setItem('tipo', result.value.tipoTramite);
        sessionStorage.setItem('km', result.value.km);
        sessionStorage.setItem('paisOrigen', result.value.paisOrigen);
        sessionStorage.setItem('numPedido', result.value.numPedido);
        this.router.navigate(['page/ayudas']);
      }
    });
  }

  modalCambio(): void{
    const dialogRef = this.dialog.open(CambioModalComponent, {
      width: '40%',
      data: {tipo: this.tipo},
      hasBackdrop: true,

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log(result.value);

        this.tipo = result.value.tipo;
        sessionStorage.setItem('numPedido', result.value.numPedido);
        sessionStorage.setItem('tipoTramite', result.value.tipoTramite);
        if (this.tipo === '1'){
          sessionStorage.setItem('tipoCliente', '1');
          this.router.navigate(['page/cambio']);
        }
        if (this.tipo === '2'){
          sessionStorage.setItem('tipoCliente', '2');
          this.router.navigate(['page/cambio']);
        }
        if (this.tipo === '3'){
          sessionStorage.setItem('tipoCliente', '3');
          this.router.navigate(['page/cambio']);
        }
      } else {
        sessionStorage.setItem('tipoCliente', 'null');
        this.router.navigate(['page/home']);
      }
    });
  }

  modalDobleCambio(): void {
    const dialogRef = this.dialog.open(DobleTrAtajoModalComponent, {
      width: '40%',
      data: {tipo: this.tipo},
      hasBackdrop: true,

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== "") {
        console.log(result.value);

        this.tipo = result.value.tipo;
        sessionStorage.setItem('numPedido', result.value.numPedido);
        sessionStorage.setItem('tipoTramite', result.value.tipoTramite);
        sessionStorage.setItem('tipoTramiteD', result.value.tipoTramiteD);
        sessionStorage.setItem('nroVentas', result.value.nroVentas);
        sessionStorage.setItem('baseImponible', result.value.baseImponible);
        sessionStorage.setItem('nroCompra', result.value.nroCompra);
        sessionStorage.setItem('baseImponibleCompra', result.value.baseImponibleCompra);

        sessionStorage.setItem('tipoCliente', '3');
        this.router.navigate(['page/doble_transferencia']);
      }
    });
  }
  toGoBajas(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO'){
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: {colaborador: this.colaborador},
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.modalAtajoBaja();
        }
      });
    } else {
      this.modalAtajoBaja();
    }
  }

  modalAtajoBaja(): void{
    const dialogRef = this.dialog.open(BajaAtajoModalComponent, {
      width: '40%',
      data: {tipo: this.tipo},
      hasBackdrop: true,

    });
    dialogRef.afterClosed().subscribe(result => {

      console.log(result.value);
      sessionStorage.setItem('tipo', result.value.tipo);

      sessionStorage.setItem('paisDestino', result.value.paisDestino);
      sessionStorage.setItem('numPedido', result.value.numPedido);
      this.router.navigate(['page/baja']);
    });
  }

  toGoFirmaDocumentos(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: {colaborador: this.colaborador},
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.modalFirmaDocumentos();
        }
      });
    } else {
      this.modalFirmaDocumentos();
    }
  }

  modalFirmaDocumentos(): void {
    sessionStorage.setItem('tipoCliente', '1');
    const dialogRef = this.dialog.open(FirmaDocumentosAtajoModalComponent, {
      width: '40%',
      data: {tipo: this.tipo},
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== '') {
        sessionStorage.setItem('tipo', result.value.tipoTramite);
        sessionStorage.setItem('tipoTramite', result.value.tramiteRelacionado);
        sessionStorage.setItem('numPedido', result.value.numPedido);
        this.router.navigate(['page/firma-documentos']);
      }
    });
  }
}
